import {Component, OnInit} from '@angular/core';
import {GlobalQuestionService} from '../../shared/services/global-question.service';
import {EntryType, SectionType} from '../../shared/constants';

@Component({
    selector: 'app-quote-pick-cover-footer',
    templateUrl: './quote-pick-cover-footer.component.html',
    styleUrls: ['./quote-pick-cover-footer.component.scss'],
    standalone: false
})
export class QuotePickCoverFooterComponent implements OnInit {

  year: any;
  entryType = EntryType;
  sectionType = SectionType;

  constructor(public globalQuestionService: GlobalQuestionService) { }

  ngOnInit(): void {
    this.year = new Date().getFullYear();
  }

}
